import { useEffect, useRef } from "react";

// Refresh open marketplace tabs after support publishes or withdraws a request.
export default function usePropertyMarketplaceRefresh(refresh) {
  const latestRefresh = useRef(refresh);
  latestRefresh.current = refresh;
  useEffect(() => {
    const refreshVisible = () => {
      if (document.visibilityState === "visible") latestRefresh.current();
    };
    const timer = setInterval(refreshVisible, 15000);
    window.addEventListener("focus", refreshVisible);
    document.addEventListener("visibilitychange", refreshVisible);
    return () => {
      clearInterval(timer);
      window.removeEventListener("focus", refreshVisible);
      document.removeEventListener("visibilitychange", refreshVisible);
    };
  }, []);
}
